import React from 'react';
import { View } from 'react-native-web';
import TemplatePage, { TemplateSection } from './TemplatePage';
import { colors, typography } from '../../utils/styling';
import { useResponsive } from '../../hooks/useResponsive';

// F5 (McKayla Loom "Current Site Feedback Part 1" t=1:47, ClickUp 86bbmtkyt):
// price by number of advisor seats, not Nitrogen's product-bundle grid.
//
// Tiers and prices are McKayla's 2026-10-05 sample, built at her instruction on
// the 2026-10-07 call: "why don't you build out what I sent you... the dollar
// amounts might change, but let's go off the assumption that that's going to be
// the structure." Final numbers are Nina's call once she sees them live
// (.claudet/DECISIONS.md 2026-10-07). Change the numbers here, nowhere else.
// No checkout is wired to these yet; firm billing waits on compliance.
const TIERS = [
  { name: 'Starter', price: 149, seats: 'Up to 2 advisors' },
  { name: 'Growth', price: 299, seats: 'Up to 5 advisors' },
  { name: 'Firm', price: 499, seats: 'Up to 10 advisors' },
];

function TierCard({ name, price, seats }: { name: string; price: number; seats: string }) {
  return (
    <View
      style={{
        flex: 1,
        minWidth: 220,
        backgroundColor: colors.white,
        border: `1px solid ${colors.gray[200]}`,
        borderRadius: 16,
        padding: 28,
        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
      }}
    >
      <h2 style={{ margin: 0, fontFamily: typography.fontFamily.body, fontWeight: 700, fontSize: 22, color: colors.dark }}>
        {name}
      </h2>
      <p style={{ margin: '16px 0 0', fontFamily: typography.fontFamily.body, color: colors.dark }}>
        <span style={{ fontSize: 40, fontWeight: 700 }}>${price}</span>
        <span style={{ fontSize: 16, color: colors.gray[600] }}> / month</span>
      </p>
      <p style={{ margin: '8px 0 0', fontFamily: typography.fontFamily.body, fontSize: 16, color: colors.gray[700] }}>
        {seats}
      </p>
    </View>
  );
}

export default function Pricing() {
  const { isMobile } = useResponsive();
  return (
    <TemplatePage
      title="Pricing"
      intro="Money Personality is priced by the number of advisor seats your firm needs. Pick the plan that fits your team, and move up as you add advisors."
    >
      <View
        style={{
          marginTop: 40,
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: 20,
        }}
      >
        {TIERS.map((t) => (
          <TierCard key={t.name} {...t} />
        ))}
      </View>
      <TemplateSection
        heading="More than 10 advisors?"
        body="Get in touch and we'll set up a plan for your firm."
      />
    </TemplatePage>
  );
}
